var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightspeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 572,
    viewBox: "0 0 384 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.211 0.763184L218.526 46.5527C223.789 56.0263 223.789 67.6053 218.526 77.079L61.6842 349.184L135.895 477.605C147.474 497.605 169.053 510.237 192.211 510.237C215.368 510.237 236.947 497.605 248.526 477.605L322.737 349.184L303.263 314.447L219.053 460.237C213.789 469.711 203.263 475.5 192.737 475.5C181.684 475.5 171.684 469.711 166.421 460.237L101.684 349.184L247.474 96.5527L273.789 142.342C279.053 151.816 279.053 163.395 273.789 172.868L172.211 349.184L192.211 383.921L302.737 192.342L375.368 318.132C386.421 337.605 386.421 361.289 375.368 380.763L301.684 508.658C290.632 528.132 255.368 571.816 192.211 571.816C129.053 571.816 94.3158 528.132 82.7369 508.658L9.05266 380.763C-1.99997 361.289 -1.99997 337.605 9.05266 318.132L192.211 0.763184Z",
    fill: "#ED5153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightspeed);
export default __webpack_public_path__ + "static/media/lightspeed.4ae41c382418126ff8a78745548a0795.svg";
export { ForwardRef as ReactComponent };